import { Alert, Button, Divider, Typography } from 'antd';
import React, { useCallback, useContext, useRef, useState } from 'react';
import { VoidItem } from '~/types/Order';
import InputQuantity from '~/App/components/InputQuantity';
import { DrawerContext } from '~/providers/DrawerProvider';
import './style.css';
import { OrderItem } from '@restaurant/api';

const VoidItemPanel = ({
  item,
  onSubmit,
}: {
  item: OrderItem;
  onSubmit: (voidItem: VoidItem | null) => void;
}) => {
  const maxQuantity = useRef(item.quantity);
  const maxAddOnQuantity = useRef(
    item.addOns?.map(({ quantity }) => quantity) ?? []
  );

  const [quantity, setQuantity] = useState(item.quantity);
  const [addOnQuantity, setAddOnQuantity] = useState(
    item.addOns?.map(({ quantity }) => quantity) ?? []
  );

  const onChangeQuantity = (value: number | null) => {
    setQuantity(Math.min(Math.max(value || 0, 0), maxQuantity.current));
  };

  const onChangeAddOnQuantity = ({
    value,
    index,
  }: {
    value: number | null;
    index: number;
  }) => {
    addOnQuantity[index] = Math.min(
      Math.max(value || 0, 0),
      maxAddOnQuantity.current[index]
    );
    setAddOnQuantity([...addOnQuantity]);
  };

  const handleSubmit = () => {
    if (quantity === 0) {
      onSubmit(null);
      return;
    }
    onSubmit({
      quantity,
      addOns: addOnQuantity,
    });
  };

  return (
    <div>
      {quantity === 0 ? (
        <Alert
          type="warning"
          message="Item akan dihapus jika kuantitas 0"
          style={{ marginBottom: 16 }}
        />
      ) : null}
      <div className="void-item-panel-row">
        <Typography.Title level={4}>{item.name}</Typography.Title>
        <InputQuantity
          value={quantity}
          onChange={onChangeQuantity}
          isPlusDisabled={quantity === maxQuantity.current}
        />
      </div>
      <Divider style={{ marginTop: 8, marginBottom: 8 }} />
      <Typography.Title level={5}>Tambahan</Typography.Title>
      {item.addOns?.map((addOn, index) => (
        <div className="void-item-panel-row" key={addOn.menuId}>
          <Typography.Text>{addOn.name}</Typography.Text>
          <InputQuantity
            value={addOnQuantity[index]}
            onChange={(value: number | null) =>
              onChangeAddOnQuantity({ value, index })
            }
            isPlusDisabled={
              addOnQuantity[index] === maxAddOnQuantity.current[index]
            }
          />
        </div>
      ))}
      <Button block onClick={handleSubmit} size="large">
        Ubah
      </Button>
    </div>
  );
};

const useOpenVoidItemPanel = () => {
  const { openDrawer } = useContext(DrawerContext);
  return useCallback(
    ({
      item,
      onSubmit,
    }: {
      item: OrderItem;
      onSubmit: (item: VoidItem | null) => void;
    }) => {
      openDrawer(({ closeDrawer }) => {
        const handleSubmit = (voidItem: VoidItem | null) => {
          closeDrawer();
          onSubmit(voidItem);
        };
        return <VoidItemPanel item={item} onSubmit={handleSubmit} />;
      });
    },
    []
  );
};

export default useOpenVoidItemPanel;
